import { Route } from 'react-router-dom'
import { URLS } from './constants'
import { PrivateRoute } from 'components/utils/PrivateRoute'
import { CollectingCompanies } from './CollectingCompanies'
import { DailyReports } from './DailyReports'
import { CollectorReports } from './CollectorReports'
import { MetiReport } from './MetiReport'
import { ExternalArticlesReport } from './ExternalArticlesReport'
import { AccompanyingNotes } from './AccompanyingNotes'
import { AccompanyingNotesReport } from './AccompanyingNotesReport'
import DailyReportsReport from './DailyReportsReport/DailyReportsReport'
import { CollectorReportsReport } from './CollectorReportsReport'
import { NoDailyReportsReport } from './NoDailyReportsReport'
import { ExternalArticlesReportsReport } from './ExternalArticlesReportsReport'

export const useWasteManagementRoutes = applicationPages => {
  return (
    <>
      <Route
        path={URLS.AUTH_COLLECTING_COMPANIES}
        element={
          <PrivateRoute component={CollectingCompanies} applicationPages={applicationPages} />
        }
      />
      <Route
        path={URLS.AUTH_DAILY_REPORTS}
        element={<PrivateRoute component={DailyReports} applicationPages={applicationPages} />}
      />
      <Route
        path={URLS.AUTH_METI_REPORTS}
        element={<PrivateRoute component={MetiReport} applicationPages={applicationPages} />}
      />
      <Route
        path={URLS.AUTH_COLLECTOR_REPORTS}
        element={<PrivateRoute component={CollectorReports} applicationPages={applicationPages} />}
      />
      <Route
        path={URLS.AUTH_EXTERNAL_ARTICLES_REPORT}
        element={
          <PrivateRoute component={ExternalArticlesReport} applicationPages={applicationPages} />
        }
      />
      <Route
        path={URLS.AUTH_ACCOMPANYING_NOTES}
        element={<PrivateRoute component={AccompanyingNotes} applicationPages={applicationPages} />}
      />
      <Route
        path={URLS.AUTH_ACCOMPANYING_NOTES_REPORT}
        element={
          <PrivateRoute component={AccompanyingNotesReport} applicationPages={applicationPages} />
        }
      />
      <Route
        path={URLS.AUTH_DAILY_REPORTS_REPORT}
        element={
          <PrivateRoute component={DailyReportsReport} applicationPages={applicationPages} />
        }
      />
      <Route
        path={URLS.AUTH_COLLECTOR_REPORTS_REPORT}
        element={
          <PrivateRoute component={CollectorReportsReport} applicationPages={applicationPages} />
        }
      />
      <Route
        path={URLS.AUTH_NO_DAILY_REPORTS}
        element={
          <PrivateRoute component={NoDailyReportsReport} applicationPages={applicationPages} />
        }
      />
      <Route
        path={URLS.AUTH_EXTERNAL_ARTICLES_REPORT_REPORT}
        element={
          <PrivateRoute
            component={ExternalArticlesReportsReport}
            applicationPages={applicationPages}
          />
        }
      />
    </>
  )
}
